import { Box, Button, Chip, Skeleton, Typography } from "@mui/material";
import { API_URL, BootstrapTooltip } from "../../utilities";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
  GridRowId,
  GridRowModel,
  GridRowModes,
  GridRowModesModel,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import moment from "jalali-moment";
import GridViewMUIX from "../../components/GridViewMUIX";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/auth";
import { MouseEvent, useEffect, useState } from "react";
import { useNotifications } from "@toolpad/core/useNotifications";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";

import PopoverComponent from "../../components/PopoverComponent";
import NewTask from "./new-task";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import SkeltonProgress from "../../components/SkeltonProgress";
import { BaseDefinitionType } from "src/interface/enum/BaseDefinitionType ";
import { IBaseDefinition } from "src/interface/IBaseDefinition";
import { ListOfStatusGlobal } from "src/interface/enum/StatusGlobal";
import { IAppUser } from "src/interface/IUser";
import { TypeUser } from "src/interface/enum/TypeUser";
import renderCellExpand from "src/GridComponents/GridExpand";
import ChangeStatus from "src/components/status-log/ChangeStatus";
import { ITask } from "src/interface/ITask";
import {
  PermissionGuard,
  ActionPermissionGuard,
  usePermissions,
} from "../../utilities/permissions";
import PageTitle from "../../components/PageTitle";
const TaskUser = () => {
  const notifications = useNotifications();
  const { user } = useAuth();
  const { canEdit, canDelete } = usePermissions();
  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ["TasksData"],
    queryFn: () =>
      fetch(API_URL + "tasks", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Accept: "application/json",
        },
      }).then((res) => res.json()),
    enabled: !!user?.token, // فقط زمانی که token موجود است
    retry: 1, // کاهش تعداد retry
    retryDelay: 1000, // تاخیر بین retry
  });
  const [rows, setRows] = useState<any>();
  const [openTask, setOpenTask] = useState<boolean>(false);
  const [openChangeTask, setOpenChangeTask] = useState<boolean>(false);

  useEffect(() => {
    if (error) {
      notifications.show("خطا در دریافت اطلاعات" + error.toString(), {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    }
  }, [error]);

  useEffect(() => {
    data && setRows(data);
  }, [data, user?.token]);
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});

  const { data: CustomersData } = useQuery({
    queryKey: ["CustomersData"],
    queryFn: () =>
      fetch(API_URL + "user/getByRole/" + TypeUser.CUSTOMER, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Accept: "application/json",
        },
      }).then((res) => res.json()),
    enabled: !!user?.token, // فقط زمانی که token موجود است
    retry: 1, // کاهش تعداد retry
    retryDelay: 1000, // تاخیر بین retry
  });
  const [getCustomers, setCustomers] = useState<IBaseDefinition[]>();
  useEffect(() => {
    if (CustomersData) {
      setCustomers(
        CustomersData.map((item: IAppUser) => ({
          label: item.fName + " " + item.lName,
          value: item.id,
        }))
      );
    }
  }, [CustomersData]);

  const { data: EditorsData } = useQuery({
    queryKey: ["EditorsData"],
    queryFn: () =>
      fetch(API_URL + "user/getByRole/" + TypeUser.EDITOR, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Accept: "application/json",
        },
      }).then((res) => res.json()),
    enabled: !!user?.token, // فقط زمانی که token موجود است
    retry: 1, // کاهش تعداد retry
    retryDelay: 1000, // تاخیر بین retry
  });
  const [getEditors, setEditors] = useState<IBaseDefinition[]>();
  useEffect(() => {
    if (EditorsData) {
      setEditors(
        EditorsData.map((item: IAppUser) => ({
          label: item.fName + " " + item.lName,
          value: item.id,
        }))
      );
    }
  }, [EditorsData]);

  const columns: GridColDef[] = [
    {
      field: "actions",
      type: "actions",
      headerAlign: "center",
      headerName: "عملیات",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      cellClassName: "actions",
      minWidth: 150,
      getActions: (params) => {
        const isInEditMode =
          rowModesModel[params.id]?.mode === GridRowModes.Edit;
        if (isInEditMode) {
          return [
            <BootstrapTooltip title="ذخیره">
              <GridActionsCellItem
                icon={<SaveIcon color="success" />}
                label="Save"
                sx={{
                  color: "primary.main",
                }}
                onClick={handleSaveClick(params.id)}
              />
            </BootstrapTooltip>,
            <BootstrapTooltip title="انصراف">
              <GridActionsCellItem
                icon={<CancelIcon color="error" />}
                label="Cancel"
                className="textPrimary"
                onClick={handleCancelClick(params.id)}
                color="inherit"
              />
            </BootstrapTooltip>,
          ];
        }
        const actions = [
          <BootstrapTooltip title="تغییر وضعیت">
            <GridActionsCellItem
              icon={<SyncProblemIcon color="warning" />}
              label="تغییر وضعیت"
              className="textPrimary"
              onClick={handleEditStatusClick(params.row)}
              color="inherit"
            />
          </BootstrapTooltip>,
        ];

        // اضافه کردن دکمه ویرایش اگر دسترسی داشته باشد
        if (canEdit("duties")) {
          actions.push(
            <BootstrapTooltip title="ویرایش">
              <GridActionsCellItem
                icon={<EditIcon color="primary" />}
                label="ویرایش"
                className="textPrimary"
                onClick={handleEditClick(params.id)}
                color="inherit"
              />
            </BootstrapTooltip>
          );
        }

        // اضافه کردن دکمه حذف اگر دسترسی داشته باشد
        if (canDelete("duties")) {
          actions.push(
            <BootstrapTooltip title="حذف">
              <GridActionsCellItem
                icon={<DeleteIcon color="error" />}
                label="حذف"
                onClick={(event) =>
                  handleDeleteClick(event, params.id.toString())
                }
                color="inherit"
              />
            </BootstrapTooltip>
          );
        }

        return actions;
      },
    },
    {
      field: "titleTask",
      headerName: "عنوان",
      align: "left",
      headerAlign: "left",
      editable: true,
      sortable: true,

      minWidth: 180,
    },
    {
      field: "statusTask",
      headerName: "وضعیت",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      type: "singleSelect",
      valueOptions: ListOfStatusGlobal,
      renderCell: (params) => {
        return (
          <Chip
            label={
              ListOfStatusGlobal.find((g) => g.value === params.value)?.label
            }
            //@ts-ignore
            color={
              ListOfStatusGlobal.find((g) => g.value === params.value)?.color
            }
            variant="filled"
          />
        );
      },
      minWidth: 150,
    },
    {
      field: "priority",
      headerName: "اولویت",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      minWidth: 80,
    },
    {
      field: "desc",
      headerName: "توضیحات",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      minWidth: 200,
      valueGetter: (value: any, row: any) => {
        // ترکیب توضیحات اصلی و توضیحات وضعیت برای جستجو
        const mainDesc = value || "";
        const statusDesc = row.statusDesc || "";
        return `${mainDesc} ${statusDesc}`.trim();
      },
      renderCell: (params: GridRenderCellParams<any, string>) => {
        return (
          <Box>
            <Typography variant="body2" style={{ whiteSpace: "pre-line" }}>
              {params.value}
            </Typography>
            {params.row.statusDesc && (
              <Typography
                variant="caption"
                color="text.secondary"
                style={{
                  whiteSpace: "pre-line",
                  display: "block",
                  marginTop: "4px",
                }}
              >
                <strong>وضعیت:</strong> {params.row.statusDesc}
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      field: "dueDate",
      headerName: "تاریخ سر رسید",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      type: "date",
      valueGetter: (params) => {
        return params ? new Date(params) : null;
      },
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
    {
      field: "customerRef",
      headerName: "مشتری",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      type: "singleSelect",
      valueOptions: getCustomers,
      minWidth: 200,
    },
    {
      field: "userRef",
      headerName: "کارمند مرتبط",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      type: "singleSelect",
      valueOptions: getEditors,
      minWidth: 180,
    },
    {
      field: "createdOn",
      headerName: "تاریخ ثبت",
      editable: false,
      sortable: true,
      headerAlign: "center",
      align: "center",
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
    {
      field: "modifiedOn",
      headerName: "آخرین تغییرات",
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
  ];

  const { mutateAsync: updateAsync, isPending: isEditLoading } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "tasks/" + body.id, {
        method: "PUT",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log("eee", error);
    },
  });

  const { mutateAsync: deleteAsync, isPending: isDeleteLoading } = useMutation({
    mutationFn: async () => {
      const response = await fetch(API_URL + "tasks/" + bankId, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Accept: "application/json",
        },
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });

  const [bankId, setBankId] = useState("");

  const [anchorDeleteEl, setAnchorDeleteEl] =
    useState<HTMLButtonElement | null>(null);
  const openDeletePopover = Boolean(anchorDeleteEl);
  const idDeletePopover = openDeletePopover ? "simple-popover" : undefined;
  const handleDeleteClick = (
    event: MouseEvent<HTMLButtonElement>,
    id: string
  ) => {
    setAnchorDeleteEl(event.currentTarget);
    setBankId(id);
  };
  const handleDeletePopoverClose = () => {
    setAnchorDeleteEl(null);
  };
  const handleDelete = async () => {
    try {
      const res = await deleteAsync();
      if (res.status) {
        notifications.show("حذف با موفقیت انجام شد!", {
          severity: "success",
          autoHideDuration: 5000,
        });
      } else {
        notifications.show("خطا در حذف!", {
          severity: "error",
          autoHideDuration: 5000,
        });
      }
    } catch (error) {
      console.log("🚀 ~ handleDelete ~ error:", error);
      notifications.show("خطا در حذف!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    } finally {
      refetch();
      handleDeletePopoverClose();
    }
  };

  function EditToolbar() {
    return (
      <GridToolbarContainer>
        <ActionPermissionGuard menuId="duties" permission="create">
          <Button
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => setOpenTask(true)}
          >
            وظیفه جدید
          </Button>
        </ActionPermissionGuard>
      </GridToolbarContainer>
    );
  }
  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };
  const [rowInfo, setRowInfo] = useState<ITask>();
  const handleEditStatusClick = (row: any) => () => {
    setOpenChangeTask(true);
    setRowInfo(row);
  };

  const handleSaveClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const processRowUpdate = async (newRow: GridRowModel) => {
    const updatedRow = { ...newRow, isNew: false };
    const res = await updateAsync(updatedRow);
    if (res.status) {
      refetch();
      setRows(
        rows.map((row: any) => (row.id === newRow.id ? updatedRow : row))
      );
      notifications.show("تغییرات اعمال شد!", {
        severity: "success",
        autoHideDuration: 5000,
      });
    } else {
      notifications.show("مشکل در ذخیره ساز!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    }
    return updatedRow;
  };

  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row: any) => row.id === id);
    if (editedRow!.isNew) {
      setRows(rows.filter((row: any) => row.id !== id));
    }
  };
  const handleClose = () => {
    setOpenTask(false);
  };
  const handleTaskChangeClose = () => {
    setOpenChangeTask(false);
  };
  return (
    <PermissionGuard menuId="tasks" permission="view">
      <>
        <PageTitle title="وظایف" />
        <PopoverComponent
          caption=" حذف انجام شود؟"
          anchorEl={anchorDeleteEl}
          handlePopoverClose={handleDeletePopoverClose}
          handler={handleDelete}
          id={idDeletePopover}
          isLoading={isDeleteLoading}
          open={openDeletePopover}
          key={"delete"}
        />

        <ChangeStatus
          open={openChangeTask}
          handleClose={handleTaskChangeClose}
          refetch={refetch}
          Taskdata={rowInfo as ITask}
        />
        <NewTask
          open={openTask}
          handleClose={handleClose}
          refetch={refetch}
          // data={rowInfo}
        />

        <Box
          sx={{
            width: {
              xs: 370, // عرض برای اندازه‌های کوچک
              sm: 500, // عرض برای اندازه‌های متوسط
              md: 720, // عرض برای اندازه‌های بزرگ
              lg: "calc(100% - 80px)", // عرض برای اندازه‌های خیلی بزرگ
              xl: "calc(100% - 80px)", // عرض برای اندازه‌های فوق‌العاده بزرگ
            },
          }}
        >
          {isLoading ? (
            <SkeltonProgress />
          ) : (
            <GridViewMUIX
              gridUniqueName="TasksUser"
              columns={columns}
              loading={isLoading || isEditLoading}
              EditToolbar={EditToolbar}
              rowModesModel={rowModesModel}
              sortFields={{ field: "modifiedOn", sort: "desc" }}
              processRowUpdate={processRowUpdate}
              rows={rows}
              setRowModesModel={setRowModesModel}
            />
          )}
        </Box>
      </>
    </PermissionGuard>
  );
};

export default TaskUser;
